import { type Computer } from '~/types';
import { ExclusiveRunner } from '~/libs/async';
import { axios } from '~/libs/axios';

const runner = ExclusiveRunner.create();

async function getAll(): Promise<Computer[]> {
  const { data } = await runner.run({
    key: ['computer', 'getAll'],
    fn: () => axios.get<Computer[]>('/computers'),
  });
  return data;
}

async function createToken(): Promise<string> {
  const { data } = await runner.run({
    key: ['computer', 'createToken'],
    fn: () => axios.post<{ token: string }>('/computers/token'),
  });
  return data.token;
}

export const computerAPI = {
  getAll,
  createToken,
};
